export default __webpack_public_path__ + "static/media/point-icon.aaae47f3.svg";